import { Route, Routes } from "react-router-dom"
import { UserGroup } from "../pages/main"
import { UserGrouopProvider } from "../provider"
import { UserGroupForm } from "../pages/form"
import PermissionGroup from "../pages/permitting"


const UserGroupRoute = () => {
    return (
        <UserGrouopProvider>
            <Routes>
                <Route path="/" element={<UserGroup />} />
                <Route path="create" element={<UserGroupForm />} />
                <Route path="edit/:id" element={<UserGroupForm />} />
                <Route path="detail/:id" element={<UserGroupForm />} />
                <Route path="permission/:id" element={<PermissionGroup />} />
            </Routes>
        </UserGrouopProvider>
    )
}

export default UserGroupRoute
